/**
 * @file Transfer 导出文件
 * @author zhuwanying02
 */

import Transfer from './Transfer';
export default Transfer;